'use strict';

import { io, config, history } from 'core';

import React from 'react';

import { Router, Redirect, Route, IndexRoute } from 'react-router';

import App from 'c';

import Internal from 'c/layout/internal';
import HSPage from 'c/layout/hsLayout';

import Home from 'c/home';
import Products from 'c/products';

io.on('router:location', _=> io.emit('router:tear'));

export const Mobile = (

    <Router history={history} onUpdate={ _=> io.emit('router:location') }>

        {/* Application store wrapper */}
        <Route component={ App }>

            {/* Internal routes, logged in, app ui */}
            <Route component={ Internal }>

                {/* Wrapper for pages with hotizontal layout */}
                <Route component={ HSPage }>

                    <Route path="/products(/:id)" component={ Home }/>

                    <Route path="*" component={ Home }/>
                    <IndexRoute component={ Home }/>
                </Route>
            </Route>
        </Route>
    </Router>
);



// WEBPACK FOOTER //
// ./app/routes.jsx